import React from 'react';

const SearchInput = ({
  onChange,
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => (
  <input
    className="govuk-input"
    id="width-20"
    name="width20"
    type="text"
    onChange={onChange}
    placeholder="Search records by name"
  />
);

export default SearchInput;
